<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import StarRating from "vue-star-rating";
import appConfig from "@/app.config";
import {
  productMethods,
  productComputed,
  cartMethods,
  cartComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Service Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, StarRating },
  data() {
    return {
      title: "Service Detail",
      productDetail: null,
      items: [
        { text: "Ecommerce", href: "/" },
        { text: "Service Detail", active: true },
      ],
      qty: 1,
      vendor_id: "",
      loader: false,
      userData: JSON.parse(localStorage.getItem("user")),
      review: "",
      reviews: [],
    };
  },
  mounted() {
    this.productDetail = this.products.filter((product) => {
      return product.product_id == parseInt(this.$route.query.id);
    });
    this.vendor_id = this.productDetail[0].user_id;
    this.fetchCarts();
    this.fetchReviews();
  },
  computed: {
    ...productComputed,
    ...cartComputed,
  },
  methods: {
    ...productMethods,
    ...cartMethods,
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "products/" + name;
      return imagelink;
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async AddtoCart() {
      this.loader = true;
      let formData = new FormData();
      formData.append("product_id", this.$route.query.id);
      formData.append("quantity", this.qty);
      formData.append("vendor_id", this.vendor_id);
      let url = "/addtocart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$toast.success("Item Added to Cart");
          this.qty = "1";
          this.loader = false;
          this.$router.push({ name: "cart" });
        }
      });
    },
    async fetchReviews() {
      let formData = new FormData();
      formData.append("product_id", this.$route.query.id);
      let url = "/fetchreviews";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.reviews = response.data.reviews;
        }
      });
    },
    async addReview() {
      this.loader = true;
      let formData = new FormData();
      formData.append("product_id", this.$route.query.id);
      formData.append("review", this.review);
      let url = "/savereview";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$toast.success("Review Added");
          this.loader = false;
          this.review = "";
          this.fetchReviews();
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="modern-product-detail">
      <!-- Back Button -->
      <div class="back-navigation">
        <button @click="$router.go(-1)" class="btn-back">
          <i class="mdi mdi-arrow-left"></i>
          <span>Go Back</span>
        </button>
      </div>

      <!-- Product Detail Section -->
      <div class="product-container">
        <div class="product-card">
          <div class="product-layout">
            <!-- Product Image -->
            <div class="product-image-section">
              <div class="image-wrapper">
                <img
                  :src="getFiles(productDetail[0].photo)"
                  :alt="productDetail[0].name"
                  class="product-image"
                />
                <div class="image-badge">
                  <i class="mdi mdi-certificate"></i>
                  <span>Featured</span>
                </div>
              </div>
            </div>

            <!-- Product Info -->
            <div class="product-info-section">
              <div class="product-header">
                <div class="category-badge">
                  <i class="mdi mdi-tag"></i>
                  {{ productDetail[0].category.name }}
                </div>
                <h1 class="product-title">{{ productDetail[0].name }}</h1>

                <!-- Rating -->
                <div class="rating-section">
                  <star-rating
                    inactive-color="#e1e8ed"
                    :show-rating="false"
                    active-color="#ffd700"
                    v-bind:star-size="20"
                  />
                  <span class="review-count">({{ reviews.length }} reviews)</span>
                </div>

                <!-- Price -->
                <div class="price-section">
                  <span class="price-label">Price</span>
                  <span class="price-value">{{ commas(productDetail[0].price) }} AED</span>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="action-section">
                <div v-if="userData" class="booking-section">
                  <button @click="AddtoCart()" :disabled="loader" class="btn-book-now">
                    <b-spinner v-if="loader" small class="btn-spinner" />
                    <template v-else>
                      <i class="mdi mdi-calendar-check"></i>
                      <span>Book Now</span>
                    </template>
                  </button>
                  <button class="btn-add-wishlist">
                    <i class="mdi mdi-heart-outline"></i>
                  </button>
                </div>

                <div v-else class="login-prompt">
                  <div class="prompt-icon">
                    <i class="mdi mdi-lock"></i>
                  </div>
                  <div class="prompt-content">
                    <h4>Login Required</h4>
                    <p>Please login to book this service</p>
                    <router-link to="/login" class="btn-login">
                      <i class="mdi mdi-account-circle"></i>
                      Login to Continue
                    </router-link>
                  </div>
                </div>
              </div>

              <!-- Description -->
              <div class="description-section">
                <h3 class="section-title">
                  <i class="mdi mdi-text"></i>
                  Description
                </h3>
                <p class="description-text">{{ productDetail[0].description }}</p>
              </div>

              <!-- Vendor Info -->
              <div class="vendor-section">
                <div class="vendor-header">
                  <i class="mdi mdi-store"></i>
                  <h3>Vendor Information</h3>
                </div>
                <router-link
                  :to="{ path: '/shop', query: { id: productDetail[0].vendor.user_id }}"
                  class="vendor-card"
                >
                  <div class="vendor-avatar">
                    <i class="mdi mdi-account-circle"></i>
                  </div>
                  <div class="vendor-details">
                    <h4 class="vendor-name">{{ productDetail[0].vendor.business_name }}</h4>
                    <div class="vendor-meta">
                      <span class="vendor-info">
                        <i class="mdi mdi-map-marker"></i>
                        {{ productDetail[0].vendor.business_address }}
                      </span>
                      <span class="vendor-info">
                        <i class="mdi mdi-phone"></i>
                        {{ productDetail[0].vendor.business_contact }}
                      </span>
                    </div>
                  </div>
                  <div class="vendor-arrow">
                    <i class="mdi mdi-chevron-right"></i>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Reviews Section -->
        <div class="reviews-container">
          <div class="reviews-header">
            <div class="header-content">
              <i class="mdi mdi-star-circle"></i>
              <div>
                <h2>Customer Reviews</h2>
                <p>{{ reviews.length }} reviews from our customers</p>
              </div>
            </div>
          </div>

          <!-- Reviews List -->
          <div class="reviews-list">
            <div v-if="reviews.length === 0" class="no-reviews">
              <i class="mdi mdi-comment-text-outline"></i>
              <h3>No reviews yet</h3>
              <p>Be the first to review this service!</p>
            </div>

            <div v-else class="review-items">
              <div v-for="item in reviews" :key="item.id" class="review-item">
                <div class="review-avatar">
                  <span v-if="item.addedby === 'Guest User'" class="avatar-letter guest">
                    G
                  </span>
                  <span v-else class="avatar-letter">
                    {{ item.addedby.first_name.charAt(0) }}
                  </span>
                </div>
                <div class="review-content">
                  <div class="review-header">
                    <h4 class="reviewer-name">
                      {{ item.addedby === "Guest User" ? "Guest User" : item.addedby.first_name }}
                    </h4>
                    <span class="review-date">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ item.addedon }}
                    </span>
                  </div>
                  <div class="review-text" v-html="item.comment"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add Review Form -->
          <div class="add-review-section">
            <div class="form-header">
              <i class="mdi mdi-comment-plus"></i>
              <h3>Write a Review</h3>
            </div>
            <form @submit.prevent="addReview" class="review-form">
              <div class="form-group">
                <label class="form-label">Your Review</label>
                <tinymce id="d1" v-model="review"></tinymce>
              </div>
              <div class="form-actions">
                <button type="submit" :disabled="loader" class="btn-submit-review">
                  <b-spinner v-if="loader" small class="btn-spinner" />
                  <template v-else>
                    <i class="mdi mdi-send"></i>
                    <span>Submit Review</span>
                  </template>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* Modern Product Detail Styles */
.modern-product-detail {
  margin: 0 auto;
  padding: 2rem 1rem;
}

/* Back Navigation */
.back-navigation {
  margin-bottom: 2rem;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem 1rem;
  background: white;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  color: #495057;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-back:hover {
  border-color: #3A2B78FF;
  color: #3A2B78FF;
  transform: translateX(-4px);
  box-shadow: 0 4px 12px rgba(0, 45, 168, 0.15);
}

.btn-back i {
  font-size: 1.2rem;
}

/* Product Container */
.product-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Product Card */
.product-card {
  background: white;
  border-radius: 16px;
  padding: 1.2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.product-layout {
  display: grid;
  grid-template-columns: 480px 1fr;
  gap: 3rem;
}

@media (max-width: 1024px) {
  .product-layout {
    grid-template-columns: 1fr;
  }
}

/* Product Image Section */
.product-image-section {
  position: relative;
}

.image-wrapper {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #f8f9fa;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.product-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  aspect-ratio: 1;
}

.image-badge {
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
  border-radius: 20px;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
}

.image-badge i {
  font-size: 1.1rem;
}

/* Product Info Section */
.product-info-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.product-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.category-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  width: fit-content;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #E6FDFF 0%, #d4f5f7 100%);
  border-radius: 20px;
  color: #3A2B78FF;
  font-weight: 600;
  font-size: 0.9rem;
}

.category-badge i {
  font-size: 1rem;
}

.product-title {
  font-size: 2.0rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.2;
}

@media (max-width: 768px) {
  .product-title {
    font-size: 1.2rem;
  }
}

/* Rating Section */
.rating-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.review-count {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
}

/* Price Section */
.price-section {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 1.0rem;
  background: linear-gradient(135deg, #FFFFFFFF 0%, #FFFFFFFF 100%);
  border-radius: 12px;
  border: 2px solid #3A2B78FF;
}

.price-label {
  font-size: 0.7rem;
  color: #575656FF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 400;
}

.price-value {
  font-size: 1.5rem;
  font-weight: 600;
  background: linear-gradient(135deg, #00d4d4 0%, #3A2B78FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Action Section */

.booking-section {
  display: flex;
  gap: 1rem;
}

.btn-book-now {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 1rem;
  background: linear-gradient(135deg, #3A2B78FF 0%, #3A2B78FF 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 39, 168, 0.3);
}

.btn-book-now:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(8, 0, 168, 0.4);
}

.btn-book-now:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-book-now i {
  font-size: 1.1rem;
}

.btn-add-wishlist {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 2px solid #e1e8ed;
  border-radius: 50px;
  color: #dc3545;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-add-wishlist:hover {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
  transform: scale(1.05);
}

/* Login Prompt */
.login-prompt {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%);
  border-radius: 12px;
  border: 2px solid #ffc107;
}

.prompt-icon {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: #ffc107;
  flex-shrink: 0;
}

.prompt-content h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #856404;
  margin: 0 0 0.2rem 0;
}

.prompt-content p {
  font-size: 0.9rem;
  color: #856404;
  margin: 0 0 1rem 0;
}

.btn-login {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #ffc107;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-login:hover {
  background: #e0a800;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.4);
  color: white;
}

/* Description Section */
.description-section {
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 1rem 0;
}

.section-title i {
  font-size: 1.5rem;
  color: #3A2B78FF;
}

.description-text {
  font-size: 1rem;
  line-height: 1.8;
  color: #495057;
  margin: 0;
}

/* Vendor Section */
.vendor-section {
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
}

.vendor-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.vendor-header i {
  font-size: 1.2rem;
  color: #3A2B78FF;
}

.vendor-header h3 {
  font-size: 1.3rem;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
}

.vendor-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.2rem;
  background: white;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.vendor-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 168, 168, 0.15);
}

.vendor-avatar {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #3A2B78FF 0%, #3A2B78FF 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: white;
  flex-shrink: 0;
}

.vendor-details {
  flex: 1;
}

.vendor-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #000000FF;
  margin: 0 0 0.5rem 0;
}

.vendor-meta {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.vendor-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #6c757d;
}

.vendor-info i {
  color: #3A2B78FF;
}

.vendor-arrow {
  font-size: 1.5rem;
  color: #3A2B78FF;
  transition: transform 0.3s ease;
}

.vendor-card:hover .vendor-arrow {
  transform: translateX(4px);
}

/* Reviews Container */
.reviews-container {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.reviews-header {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #f8f9fa;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-content > i {
  font-size: 3rem;
  color: #ffd700;
}

.header-content h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.25rem 0;
}

.header-content p {
  font-size: 1rem;
  color: #6c757d;
  margin: 0;
}

/* Reviews List */
.reviews-list {
  margin-bottom: 2rem;
}

.no-reviews {
  text-align: center;
  padding: 3rem 2rem;
  background: #f8f9fa;
  border-radius: 12px;
}

.no-reviews i {
  font-size: 4rem;
  color: #3A2B78FF;
  margin-bottom: 1rem;
}

.no-reviews h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
}

.no-reviews p {
  font-size: 1rem;
  color: #6c757d;
  margin: 0;
}

.review-items {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.review-item {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.review-item:hover {
  background: linear-gradient(135deg, #E6FDFF 0%, #f8f9fa 100%);
}

.review-avatar {
  flex-shrink: 0;
}

.avatar-letter {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #00d4d4 0%, #3A2B78FF 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
}

.avatar-letter.guest {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
}

.review-content {
  flex: 1;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.reviewer-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.review-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #6c757d;
}

.review-text {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #495057;
}

/* Add Review Section */
.add-review-section {
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
}

.form-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.form-header i {
  font-size: 1.5rem;
  color: #3A2B78FF;
}

.form-header h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.review-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  font-weight: 500;
  color: #495057;
  font-size: 0.95rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

.btn-submit-review {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 2rem;
  background: linear-gradient(135deg, #00d4d4 0%, #3A2B78FF 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 168, 168, 0.3);
}

.btn-submit-review:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 168, 168, 0.4);
}

.btn-submit-review:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-spinner {
  width: 1.2rem;
  height: 1.2rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-product-detail {
    padding: 1rem 0.5rem;
  }

  .product-card {
    padding: 1.5rem;
  }

  .product-layout {
    gap: 2rem;
  }

  .price-value {
    font-size: 2rem;
  }

  .booking-section {
    flex-direction: column;
  }

  .btn-add-wishlist {
    width: 100%;
    height: 50px;
  }

  .login-prompt {
    flex-direction: column;
    text-align: center;
  }

  .vendor-card {
    flex-wrap: wrap;
  }

  .reviews-container {
    padding: 1.5rem;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .review-item {
    flex-direction: column;
  }

  .add-review-section {
    padding: 1.5rem;
  }

  .form-actions {
    justify-content: stretch;
  }

  .btn-submit-review {
    width: 100%;
  }
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.product-card,
.reviews-container {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.image-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 3s infinite;
}

/* Loading Pulse */
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.btn-spinner {
  animation: pulse 1.5s infinite;
}

/* Badge Animation */
@keyframes badge-bounce {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.image-badge {
  animation: badge-bounce 2s ease-in-out infinite;
}

/* Price Glow Effect */
@keyframes price-glow {
  0%,
  100% {
    box-shadow: 0 0 10px rgba(0, 168, 168, 0.2);
  }
  50% {
    box-shadow: 0 0 20px rgba(0, 168, 168, 0.4);
  }
}

.price-section {
  animation: price-glow 3s ease-in-out infinite;
}

/* Accessibility */
*:focus-visible {
  outline: 3px solid #3A2B78FF;
  outline-offset: 2px;
}

/* Button Active State */
.btn-book-now:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 168, 168, 0.3);
}

.btn-back:active {
  transform: translateX(-2px);
}

/* Hover Effect for Image */
.image-wrapper:hover .product-image {
  transform: scale(1.05);
  transition: transform 0.5s ease;
}

/* Star Rating Container */
.rating-section::v-deep .vue-star-rating {
  display: flex;
  align-items: center;
}

/* Tooltip for Icons */
[title] {
  position: relative;
}

/* Scrollbar Styling */
.review-items::-webkit-scrollbar {
  width: 8px;
}

.review-items::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 10px;
}

.review-items::-webkit-scrollbar-thumb {
  background: #3A2B78FF;
  border-radius: 10px;
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .btn-book-now,
  .btn-back,
  .btn-login,
  .btn-submit-review {
    border-width: 3px;
  }

  .product-card,
  .reviews-container {
    border: 2px solid #3A2B78FF;
  }
}

/* Print Styles */
@media print {
  .back-navigation,
  .action-section,
  .add-review-section {
    display: none;
  }

  .product-card,
  .reviews-container {
    box-shadow: none;
    border: 1px solid #e1e8ed;
  }

  .product-layout {
    grid-template-columns: 1fr;
  }
}

/* Focus Trap for Modal-like Sections */
.add-review-section:focus-within {
  box-shadow: 0 0 0 4px rgba(0, 168, 168, 0.15);
}

/* Skeleton Loading State (Optional Enhancement) */
.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Vendor Card Hover Gradient */
.vendor-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 168, 168, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

.vendor-card:hover::before {
  left: 100%;
}

.vendor-card {
  position: relative;
  overflow: hidden;
}

/* Review Item Border on Hover */
.review-item {
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
}

.review-item:hover {
  border-left-color: #3A2B78FF;
}

/* Interactive Star Rating */
.rating-section::v-deep .vue-star-rating-star {
  transition: transform 0.2s ease;
}

.rating-section::v-deep .vue-star-rating-star:hover {
  transform: scale(1.2);
}

/* Add to Wishlist Animation */
@keyframes heartbeat {
  0%,
  100% {
    transform: scale(1);
  }
  10%,
  30% {
    transform: scale(0.9);
  }
  20%,
  40% {
    transform: scale(1.1);
  }
}

.btn-add-wishlist:active {
  animation: heartbeat 0.6s ease-in-out;
}

/* Category Badge Hover */
.category-badge {
  transition: all 0.3s ease;
}

.category-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 168, 168, 0.2);
}

/* Description Text Selection */
.description-text::selection {
  background: rgba(0, 168, 168, 0.2);
  color: #1a1a1a;
}

/* Review Text Selection */
.review-text::selection {
  background: rgba(0, 168, 168, 0.2);
  color: #495057;
}

/* Smooth Scrolling */
html {
  scroll-behavior: smooth;
}

/* Image Loading State */
.product-image {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
}

.product-image[src] {
  background: none;
}

/* Empty State for Reviews */
.no-reviews {
  position: relative;
  overflow: hidden;
}

.no-reviews::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(0, 168, 168, 0.05) 0%,
    transparent 70%
  );
  animation: pulse 3s infinite;
}

/* Form Validation States */
.form-group.error .form-control {
  border-color: #dc3545;
}

.form-group.success .form-control {
  border-color: #28a745;
}

/* Gradient Overlay for Long Text */
.description-text.clamped {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  position: relative;
}

.description-text.clamped::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2rem;
  background: linear-gradient(transparent, #f8f9fa);
}

/* Vendor Info Separator */
.vendor-meta .vendor-info + .vendor-info::before {
  content: '•';
  margin: 0 0.5rem;
  color: #e1e8ed;
}

@media (max-width: 768px) {
  .vendor-meta .vendor-info + .vendor-info::before {
    display: none;
  }
}

/* Sticky Elements */
@media (min-width: 1024px) {
  .product-image-section {
    position: sticky;
    top: 2rem;
  }
}

/* Link Hover Effect */
a {
  transition: all 0.3s ease;
}

/* Number Input Styling */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

/* Button Group Spacing */
.booking-section > * + * {
  margin-left: 0;
}

/* Consistent Border Radius */
* {
  box-sizing: border-box;
}

/* Icon Rotation on Hover */
.vendor-arrow i {
  transition: transform 0.3s ease;
}

/* Success Toast Integration */
.toast-success {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

/* Loading State for Form */
.review-form.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Enhanced Box Shadows */
.product-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.reviews-container:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

/* Text Overflow Handling */
.product-title {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.vendor-name {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Safe Area for Notched Devices */
@supports (padding: max(0px)) {
  .modern-product-detail {
    padding-left: max(1rem, env(safe-area-inset-left));
    padding-right: max(1rem, env(safe-area-inset-right));
  }
}

/* Dark Mode Support (Optional) */
@media (prefers-color-scheme: dark) {
  .modern-product-detail {
    /* background: #F9F8F8FF; */
  }

  .product-card,
  .reviews-container {
    background: #FFFFFFFF;
    color: #0C0C0CFF;
  }

  .reviewer-name {
    color: #ffffff;
  }

  .description-text,
  .review-text {
    color: #b0b0b0;
  }
}
</style>